import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  en: {
    translation: {
      loading: "Loading...",
      sick_person: "Sick Person",
      no_diseases_added: "No diseases added",
      person_cannot_talk: "I am non-verbal",
      primary_disease_note: "The first disease is highlighted as primary",
      preview_notice: "This is how the information appears when someone scans the wristband",
      share_location: "ALLOW LOCATION SHARING - in order that emergency contacts are informed of your location.",
      location_shared: "Location shared successfully",
      register_wristband: "Register Wristband",
      bad_token: "Invalid or expired token",
      medical_information: "Medical information",
      birth_year: "Birth year",
      years_old: "years old",
      sex: "Sex",
      sex_male: "Male",
      sex_female: "Female",
      sex_unspecified: "Unspecified",
      blood_type: "Blood type"
    }
  },
  sv: {
    translation: {
      loading: "Laddar...",
      sick_person: "Sjuk person",
      no_diseases_added: "Inga sjukdomar tillagda",
      person_cannot_talk: "Är icke-verbal",
      primary_disease_note: "Den första sjukdomen är markerad som primär",
      preview_notice: "Detta är hur informationen kommer att visas när någon skannar armbandet",
      share_location: "TILLÅT PLATSDELNING - så att anhöriga underrättas om var du befinner dig.",
      location_shared: "Plats delad framgångsrikt",
      register_wristband: "Registrera armband",
      bad_token: "Ogiltig eller utgången token",
      medical_information: "Medicinsk information",
      birth_year: "Födelseår",
      years_old: "år",
      sex: "Kön",
      sex_male: "Man",
      sex_female: "Kvinna",
      sex_unspecified: "Ospecificerad",
      blood_type: "Blodgrupp"
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: ['en', 'sv'],
    detection: {
      order: ['querystring', 'cookie', 'localStorage', 'navigator'],
      caches: ['localStorage', 'cookie'],
      cookieOptions: {
        path: '/',
        domain: window.location.hostname.includes('tuutuum.se') 
          ? '.tuutuum.se' 
          : window.location.hostname,
        sameSite: 'lax'
      }
    },
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
